import { render, staticRenderFns } from "./fenlei.vue?vue&type=template&id=05fdf459&scoped=true&"
import script from "./fenlei.vue?vue&type=script&lang=js&"
export * from "./fenlei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fdf459",
  null
  
)

export default component.exports